(function ($, window, document, undefined) {
    var Banner = function (elem, options) {
        this.elem = elem;
        this.$elem = $(elem);
        this.options = options;
        this.metadata = this.$elem.data('slider-options');
        this.$slides = this.$elem.find('.slides').children('li');
        this.$slidesTextContainer = this.$elem.find('.slides-text');
        this.$slidesText = this.$slidesTextContainer.find('li');
        this.$nav = this.$elem.find('.slider-nav');
        this.isAnimating = false;
        this.isAutoRotating = true;
    };
    Banner.prototype = {
        defaults: {
            currentClass: 'current',
            transition: 8000
        },
        init: function () {
            this.config = $.extend({}, this.defaults, this.options, this.metadata);
            this.$currentSlide = this.$slides.filter('.' + this.config.currentClass);
            this.$slidesTextCurrent = this.$slidesText.filter('.' + this.config.currentClass);
            this.setPrevNext();
            if (this.$slides.length > 2) {
                this.$nav.on('click', 'a', $.proxy(this.handleClick, this));
            } else {
                this.$nav.remove();
            }
            this.initTimeout();
            this.$elem.on('mouseover.slider click.slider', $.proxy(this.cancelTimeout, this));
            return this;
        },
        adjustCurrentImageSlide: function ($this, $newCurrent) {
            this.isAnimating = false;
            this.$currentSlide.removeClass(this.config.currentClass);
            $newCurrent.addClass(this.config.currentClass);
            this.$currentSlide = $newCurrent;
            $this.removeClass('prev next').removeAttr('style');
            this.setPrevNext();
        },
        adjustCurrentTextSlide: function (currentPosition) {
            var $newTextCurrent = this.$slidesText.eq(currentPosition);
            this.$slidesTextCurrent.removeClass(this.config.currentClass);
            $newTextCurrent.addClass(this.config.currentClass);
            this.$slidesTextContainer.delay(100).animate({
                opacity: 1
            }, 700);
            this.$slidesTextCurrent = $newTextCurrent;
        },
        cancelTimeout: function () {
            clearTimeout(this.t);
            this.isAutoRotating = false;
            this.$elem.one('mouseleave.slider', $.proxy(this.restartTimeout, this));
        },
        changeSlide: function (direction) {
            var self = this;
            var $newCurrent = (direction === 'next') ? self.$nextSlide : self.$prevSlide;
            var currentPosition = $newCurrent.prevAll().length;
            var delta = (direction === 'next') ? '-' : '+';
            self.$slidesTextContainer.animate({
                opacity: 0
            }, 200, function () {
                self.adjustCurrentTextSlide(currentPosition);
            });
            self.$currentSlide.add(self.$nextSlide).add(self.$prevSlide).animate({
                left: delta + '=100%'
            }, 2000, 'easeOutQuart').promise().done(function () {
                self.adjustCurrentImageSlide($(this), $newCurrent);
            });
            if (this.isAutoRotating) {
                this.initTimeout();
            }
        },
        handleClick: function (e) {
            var $this = $(e.currentTarget);
            var direction = ($this.hasClass('next')) ? 'next' : 'prev';
            if (!this.isAnimating) {
                this.isAnimating = true;
                this.changeSlide(direction);
            }
            e.preventDefault();
        },
        initTimeout: function () {
            clearTimeout(this.t);
            this.t = setTimeout($.proxy(this.changeSlide, this, 'next'), this.config.transition);
        },
        restartTimeout: function () {
            this.isAutoRotating = true;
            this.initTimeout();
        },
        setPrevNext: function () {
            this.$prevSlide = this.$currentSlide.prev();
            this.$nextSlide = this.$currentSlide.next();
            if (this.$nextSlide.length === 0) {
                this.$nextSlide = this.$slides.first();
            }
            if (this.$prevSlide.length === 0) {
                this.$prevSlide = this.$slides.last();
            }
            this.$prevSlide.addClass('prev');
            this.$nextSlide.addClass('next');
        }
    };
    Banner.defaults = Banner.prototype.defaults;
    $.fn.banner = function (options) {
        return this.each(function () {
            new Banner(this, options).init();
        });
    };
})(jQuery, window, document);
